import {lazy} from 'react';

export const CompactTabNavigationLazy = lazy(() => import(/* webpackChunkName: "compactTabNavigation" */ '.'));
